import {AfterContentInit, Component, OnDestroy, OnInit} from '@angular/core';
import {LoggingService} from '../logging.service';
import {DataService} from '../shared/data.service';
import {LichessRequestModel} from './model/lichess.request.model';
import {LichessService} from './lichess.service';
import {LichessPlayeridModel} from './model/lichess.playerid.model';
import {LichessActivityModel} from './model/lichess.activity.model';
import {LichessGameModel} from './model/lichess.game.model';
import {Subject, Subscription} from 'rxjs';
import {LichessUserModel} from './model/lichess.user.model';

@Component({
  selector: 'app-chess',
  templateUrl: './chess.component.html',
  styleUrls: ['./chess.component.css'],
  providers: [ DataService, LichessService]
})
export class ChessComponent implements OnDestroy {


  lichessRequest: LichessRequestModel = new LichessRequestModel(
    'sentrworks', true, 20, false, true, false, false, true
  );

  choosenUser: string;
  choosenGame: string;
  showModal = false;

  selectedGames: LichessGameModel [];
  myFollowers: LichessPlayeridModel[] = [];

  filteredPlayer = '';

  activities: LichessActivityModel[] = [];

  users: LichessUserModel[] = [];

  selectedUser(username: string) {
    this.choosenUser = username;
    this.lichessRequest.username = username;

    this.lichessService.getGames(this.lichessRequest)
      .subscribe(
        (response) => {

          console.log('Get Games for ' + username );
          this.selectedGames = response;
        }
        // (err) => console.log(err)
      );
  }




  openModal(gameId: string) {
    this.choosenGame = 'https://lichess.org/embed/' + gameId + '?theme=auto&bg=auto';
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  sortyBy(column: string) {
    this.users.sort((a, b) => {

      if ( b.seenAt > a.seenAt) {
        return 1;
      }
      if ( b.seenAt < a.seenAt) {
        return -1;
      }

      return 0;
    });

  }

  constructor( private loggingService: LoggingService,
               private dataService: DataService,
               private lichessService: LichessService) {
    this.choosenUser = 'sentrworks';
    this.selectedGames = [];
    console.log('How many times constructor initialized');

    if (this.users.length === 0) {
      this.dataService.getChessPlayers()
        .subscribe(
          (lichessPlayers: LichessPlayeridModel[]) => {

            console.log('the size of the followers ' + lichessPlayers.length);

            // this.subjectFollowers.next(followers);

            const letMeString: string[] = [];

            for (const player of lichessPlayers) {
              if (player != null) {
                letMeString.push(player.id);
              }
            }

            this.lichessService.getUsersV2(letMeString.toString()).subscribe(
              response => {
                //console.log(response);
                this.users = response;
              }
            );
          }
          // (err) => console.log(err)
        );
    }
  }



ngOnDestroy(): void {

  this.users = [];
  console.log('unsubscribed from all the services ..');
}


}
